import React, { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Spinner from '../layout/Spinner';
import ProfileTop from './ProfileTop';
import ProfileAbout from './ProfileAbout';
import ProfileExperience from './ProfileExperience';
import ProfileEducation from './ProfileEducation';
import ProfilePosts from './ProfilePosts';
import PostItem from '../posts/PostItem';
import { getProfileById } from '../../actions/profile';
import { getUsersPosts } from '../../actions/post';

const Profile = ({
  getProfileById,
  profile: { profile, loading },
  auth,
  match
}) => {
  useEffect(() => {
    getProfileById(match.params.id);
    // getUsersPosts(match.params.id);
  }, [getProfileById, match.params.id]);

  // return (
  //   <Fragment>
  //     {profile === null || loading ? (
  //       <Spinner />
  //     ) : (
  //       <Fragment>
  //         <div className="row justify-content-center">
  //           <div className="col-12 col-md-10 col-lg-10 my-1">
  //             {auth.isAuthenticated &&
  //             auth.loading === false &&
  //             auth.user._id === profile.user._id ? (
  //               <ProfileTop profile={profile} usersProfile={true} />
  //             ) : (
  //               <ProfileTop profile={profile} usersProfile={false} />
  //             )}
  //           </div>
  //         </div>
  //         <div className="row justify-content-center">
  //           <div className="col-12 col-md-10 col-lg-4 col-xl-4 my-0">
  //             <div className="card rounded-0 shadow-sm mb-3">
  //               <ProfileAbout profile={profile} />
  //               <div className="profile-credentials">
  //                 {profile.education.length > 0 && (
  //                   <Fragment>
  //                     <div className="profile-edu">
  //                       {profile.education.map((education) => (
  //                         <ProfileEducation
  //                           key={education._id}
  //                           education={education}
  //                         />
  //                       ))}
  //                     </div>
  //                   </Fragment>
  //                 )}
  //                 {profile.experience.length > 0 && (
  //                   <Fragment>
  //                     <div className="profile-exp">
  //                       {profile.experience.map((experience) => (
  //                         <ProfileExperience
  //                           key={experience._id}
  //                           experience={experience}
  //                         />
  //                       ))}
  //                     </div>
  //                   </Fragment>
  //                 )}
  //               </div>
  //             </div>
  //           </div>

  //           <div className="col-12 col-md-10 col-lg-6 col-xl-6 my-0">
  //             <ProfilePosts userId={match.params.id} />
  //             {/* <div className="posts">
  //               {posts.map((post) => (
  //                 <PostItem key={post._id} post={post} />
  //               ))}
  //             </div> */}
  //           </div>
  //         </div>
  //       </Fragment>
  //     )}
  //   </Fragment>
  // );

  return profile === null && loading ? (
    <Spinner />
  ) : (
    <Fragment>
      {profile !== null ? (
        <Fragment>
          <div className="row justify-content-center">
            <div className="col-12 col-md-10 col-lg-10 my-1">
              {auth.isAuthenticated &&
              auth.loading === false &&
              auth.user._id === profile.user._id ? (
                <ProfileTop profile={profile} usersProfile={true} />
              ) : (
                <ProfileTop profile={profile} usersProfile={false} />
              )}
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-12 col-md-10 col-lg-4 col-xl-4 my-0">
              <div className="card rounded-0 shadow-sm mb-3">
                <ProfileAbout profile={profile} />
                <div className="profile-credentials">
                  {profile.education.length > 0 && (
                    <Fragment>
                      <div className="profile-edu">
                        {profile.education.map((education) => (
                          <ProfileEducation
                            key={education._id}
                            education={education}
                          />
                        ))}
                      </div>
                    </Fragment>
                  )}
                  {profile.experience.length > 0 && (
                    <Fragment>
                      <div className="profile-exp">
                        {profile.experience.map((experience) => (
                          <ProfileExperience
                            key={experience._id}
                            experience={experience}
                          />
                        ))}
                      </div>
                    </Fragment>
                  )}
                </div>
              </div>
            </div>

            <div className="col-12 col-md-10 col-lg-6 col-xl-6 my-0">
              <ProfilePosts userId={match.params.id} />
            </div>
          </div>
        </Fragment>
      ) : (
        <Fragment>
          <div className="row justify-content-center">
            {/* <div className="col-12 col-md-9 col-lg-7 col-xl-5">
              <div id="create-profile">
                <div className="card-body">
                  <p>You have not yet setup a profile, please add some info</p>
                  <p>Your profile is not yet visible to others.</p>
                  <Link to="/create-profile" className="btn btn-primary">
                    Create Profile
                  </Link>
                </div>
              </div>
            </div> */}
            <div className="col-11 col-sm-8 col-md-8 col-lg-5 col-xl-4">
              <div id="create-profile-card">
                <div className="card-body">
                  <p>You have not yet setup a profile, please add some info</p>
                  <Link
                    to="/create-profile"
                    className="btn profile-form-btn primary-btn"
                  >
                    Create Profile
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </Fragment>
      )}
    </Fragment>
  );
};

Profile.propTypes = {
  getProfileById: PropTypes.func.isRequired,
  profile: PropTypes.object.isRequired,
  // getUsersPosts: PropTypes.func.isRequired,
  // post: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
  profile: state.profile,
  // post: state.post,
  auth: state.auth
});

export default connect(mapStateToProps, { getProfileById })(Profile);
